var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"key"},[_vm._v(_vm._s(_vm.name)+": ")]),_c('a',{staticClass:"value",class:( _obj = {expandable:!!_vm.callback||!!_vm.link}, _obj[_vm.type] = !!_vm.type, _obj ),attrs:{"href":_vm.link,"target":"_blank"},on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.str(_vm.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }